import { gql } from '@apollo/client'

export const COMPANIES_OF_USER = gql`
  query CompaniesOfUser {
    companiesOfUser {
      companyId
      companyName
      editable
    }
  }
`

// Includes company-country pairs for which the user is HR or company manager or network/cluster manager or hrbp
export const COMPANIES_MANAGER_OF_OR_RESPONSIBLE_OF = gql`
  query FindCompaniesAndCountriesByManagerOrResponsible($businessPartnerVisibility: Boolean!) {
    findCompaniesAndCountriesByManagerOrResponsible(businessPartnerVisibility: $businessPartnerVisibility) {
      companyId
      companyName
      companyCountries {
        legalEntityId
        legalEntityName
        country
      }
    }
  }
`

// Includes companies for which the user is HR or company manager or network/cluster manager or hrbp
export const COMPANIES_BY_MANAGER_OR_RESPONSIBLE = gql`
  query FindCompaniesByManagerOrResponsible($businessPartnerVisibility: Boolean!) {
    findCompaniesByManagerOrResponsible(businessPartnerVisibility: $businessPartnerVisibility) {
      id
      name
    }
  }
`

// Includes company-country pairs for which the user is HR or company manager
export const MANAGER_OF_COMPANY_OR_RESPONSIBLE_OF = gql`
  query FindCompaniesAndCountriesByCompanyManagerOrResponsible {
    findCompaniesAndCountriesByCompanyManagerOrResponsible {
      companyId
      companyName
      companyCountries {
        legalEntityId
        legalEntityName
        country
      }
    }
  }
`

// Includes company-country pairs for which the user is HR
export const COMPANIES_OF_RESPONSIBLE = gql`
  query FindCompaniesAndCountriesByResponsible {
    findCompaniesAndCountriesByResponsible {
      companyId
      companyName
      companyCountries {
        legalEntityId
        legalEntityName
        country
      }
    }
  }
`

// Includes company-country pairs for which the user is hrbp or company manager
export const COMPANIES_AND_COUNTRIES_OF_COMPANY_MANAGER = gql`
  query FindCompaniesAndCountriesByCompanyManager($excludeBusinessPartnerCompanies: Boolean = false) {
    findCompaniesAndCountriesByCompanyManager(excludeBusinessPartnerCompanies: $excludeBusinessPartnerCompanies) {
      companyId
      companyName
      companyCountries {
        legalEntityId
        legalEntityName
        country
      }
    }
  }
`

// Includes company-country pairs for which the user is company manager or hrbp or network/cluster manager
export const COMPANIES_OF_NETWORK_OR_COMPANY_MANAGER_OR_HRBP = gql`
  query FindCompaniesAndCountriesByNetworkOrCompanyManagerOrHRBP {
    findCompaniesAndCountriesByNetworkOrCompanyManagerOrHRBP {
      companyId
      companyName
      companyCountries {
        legalEntityId
        legalEntityName
        country
      }
    }
  }
`

export const USER_MANAGER_ROLES_BY_COMPANY = gql`
  query FindUserManagerRolesByCompany($companyId: HashedId!) {
    findUserManagerRolesByCompany(companyId: $companyId)
  }
`

export const USER_MANAGER_ROLES_BY_EMPLOYEE = gql`
  query FindUserManagerRolesByEmployee($employeeId: HashedId!) {
    findUserManagerRolesByEmployee(employeeId: $employeeId)
  }
`

export const COMPANY_SEARCH = gql`
  query CompanySearch($companyScope: CompanyScope!, $search: String!, $limit: Int!) {
    companySearch(companyScope: $companyScope, search: $search, limit: $limit) {
      id
      name
    }
  }
`
